import i18n from '../VueI18n'

/**
 *
 * @param {Object} categoriaDeArvore Categoria de Arvore que deve ser validada
 * @param {Array<Object>} categoriasDeArvores Lista de categorias de arvores que devem ser usados para validacao
 */
const validarCategoriaDeArvore = (categoriaDeArvore, categoriasDeArvores) => {
	if (!isUnique(categoriaDeArvore, categoriasDeArvores)) {
		return {
			isValid: false,
			message: `${i18n.t('aCategoriaDeArvore')} "${categoriaDeArvore.ctga_nm_nome}" ${i18n.t('jaEstaCadastradaNoSistema')}`,
		}
	}
	return { isValid: true }
}

/**
 * Valida se a categoria de árvore possui valores unicos considerando:
 * - ctga_nm_nome
 * @param {Object}  categoriaDeArvore que deve ser validado
 * @param {Array<Object>} categoriasDeArvores Lista de parcelas que devem ser usados para validacao
 */
function isUnique(categoriaDeArvore, categoriasDeArvores) {
	return (
		categoriasDeArvores.filter(
			(categoriaDeArvoreDaLista) =>
				categoriaDeArvoreDaLista.ctga_nm_nome.toLowerCase() ===
				categoriaDeArvore.ctga_nm_nome.toLowerCase(),
		).length === 0
	)
}

export default validarCategoriaDeArvore
